module.exports = __webpack_public_path__ + "static/media/valor3_1.4b5980e5.png";